/*
  Live-Produktpreise (Okt 2026). Problem: Die GPE-App setzt die Shopify-Preise neu, eine geöffnete Seite zeigt aber
  den Preis vom Laden der Seite – Kunden kamen mit altem Preis auf dem Handy in den Laden.
  Lösung: Preise NUR holen, wenn die App einen neuen Kurs geschrieben hat (Ereignis „ma:kurs“ von ma-kurs.js mit
  neuem Zeitstempel „at“ = GPE last_updated_on) und wenn der Kunde zur Seite zurückkommt. Kein fester Takt.
  Die App setzt die Produktpreise kurz nach dem Kurs (nacheinander) → nach einem neuen Kurs zweimal nachfassen.
    - [data-ma-preis="<Varianten-ID>"] neu schreiben (Produktpreis, Handy-Warenkorb-Leiste),
    - [data-ma-preis-zeit] mit „Preis von HH:MM Uhr“ füllen = Stand der App, nicht der Abfrage,
    - Ereignis „ma:preis“ melden (detail: { variants: {id: cent}, handles: {handle: cent}, at, money }) –
      darauf hören ma-spot-info (Aufpreis/Rückkauf) und ma-filter-grid (Karten).
  Quelle: /products/<handle>.js auf der Produktseite, /collections/<handle>/products.json für Karten-Raster,
  Zeitstempel aus /?sections=ma-kurs-data (dieselbe Abfrage wie ma-kurs.js).
*/
(() => {
  const FMT = window.MA_MONEY_FORMAT || '€{{amount_with_comma_separator}}';
  const NACHFASSEN = [20, 90]; // Sekunden nach neuem App-Kurs
  const money = cents => {
    const n = (cents / 100).toFixed(2), [i, d] = n.split('.');
    const comma = FMT.includes('comma_separator');
    const iFmt = i.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    return FMT.replace(/\{\{\s*amount\w*\s*\}\}/, iFmt + (comma ? ',' : '.') + d);
  };
  const zeit = d => d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  const fresh = u => u + (u.includes('?') ? '&' : '?') + '_=' + Date.now();

  const handleEl = document.querySelector('[data-ma-preis-handle]');
  const handle = handleEl && handleEl.dataset.maPreisHandle;
  const hasGrid = !!document.querySelector('.mgh-card[data-handle]');
  if (!handle && !hasGrid) return;

  let appAt = null; // Stand der App (Date)
  async function appStand() {
    try {
      const r = await fetch(fresh('/?sections=ma-kurs-data'), { cache: 'no-store' });
      const html = (await r.json())['ma-kurs-data'] || '';
      const m = html.match(/<script[^>]*id="ma-kurs-data"[^>]*>([\s\S]*?)<\/script>/);
      const d = m ? JSON.parse(m[1]) : null;
      if (d && d.at) appAt = new Date(d.at);
    } catch (e) { /* Uhrzeit bleibt beim letzten Stand */ }
  }

  async function gridPrices() {
    const m = location.pathname.match(/\/collections\/([^/?#]+)/);
    const base = `/collections/${m ? m[1] : 'all'}/products.json?limit=250`;
    const out = {};
    for (let page = 1; page <= 4; page++) {
      const r = await fetch(fresh(`${base}&page=${page}`), { cache: 'no-store' });
      if (!r.ok) break;
      const list = (await r.json()).products || [];
      list.forEach(p => {
        const c = p.variants.map(v => Math.round(parseFloat(v.price) * 100)).filter(n => n > 0);
        if (c.length) out[p.handle] = Math.min(...c);
      });
      if (list.length < 250) break;
    }
    return out;
  }

  let busy = false, lastLoad = 0;
  async function load(withStand) {
    if (busy) return;
    busy = true; lastLoad = Date.now();
    try {
      if (withStand) await appStand();
      const variants = {};
      let handles = {};
      if (handle) {
        const r = await fetch(fresh(`/products/${handle}.js`), { cache: 'no-store' });
        if (r.ok) (await r.json()).variants.forEach(v => { variants[v.id] = v.price; });
      }
      if (hasGrid) handles = await gridPrices();
      if (!Object.keys(variants).length && !Object.keys(handles).length) return;
      document.querySelectorAll('[data-ma-preis]').forEach(el => {
        const c = variants[el.dataset.maPreis];
        if (c > 0) el.textContent = money(c);
      });
      if (appAt) document.querySelectorAll('[data-ma-preis-zeit]').forEach(el => {
        const t = el.querySelector('[data-ma-preis-uhr]');
        if (t) t.textContent = zeit(appAt);
        el.hidden = false;
      });
      document.dispatchEvent(new CustomEvent('ma:preis', { detail: { variants, handles, at: appAt, money } }));
    } catch (e) { /* nächster Versuch beim nächsten App-Kurs */ } finally { busy = false; }
  }

  const start = () => {
    load(true);
    // Neuer Kurs der App (ma-kurs.js fragt den Stand ohnehin ab): Preise holen und nachfassen
    let timers = [];
    document.addEventListener('ma:kurs', e => {
      const d = e.detail;
      if (!d || d.source !== 'GPE-App' || !d.at) return;
      const at = new Date(d.at);
      if (appAt && at.getTime() === appAt.getTime()) return;
      const first = !appAt;
      appAt = at;
      if (first) return load(false); // erster Stand beim Seitenaufruf
      timers.forEach(clearTimeout);
      load(false);
      timers = NACHFASSEN.map(s => setTimeout(() => load(false), s * 1000));
    });
    // Handy entsperrt / Tab wieder vorne / Seite aus dem Zurück-Cache: sofort nachsehen
    const back = () => { if (!document.hidden && Date.now() - lastLoad > 15000) load(true); };
    document.addEventListener('visibilitychange', back);
    window.addEventListener('pageshow', e => { if (e.persisted) back(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
